<script>
import { mapGetters } from 'vuex'
import actions from './actions'
export default {
    mixins: [actions],

    computed: mapGetters({ company: 'company' }),
}
</script>

<template lang="pug">
acrm-panel
    .row
        .col-md-12
            acrm-hidden-input.mb-3(v-model="company.name" @save="save")
                label {{ $t('COMPANIES.NAME')}}
                div {{ company.name }}
                acrm-input-line.mb-1(slot="edit" v-model="company.name") {{ $t('COMPANIES.NAME')}}
            acrm-hidden-input.mb-3(v-model="company.address" @save="save")
                label {{ $t('COMPANIES.ADDRESS')}}
                div {{ company.address }}
                acrm-input-line.mb-1(slot="edit" v-model="company.address") {{ $t('COMPANIES.ADDRESS')}}
            acrm-hidden-input.mb-3(v-model="company.phone" @save="save")
                label {{ $t('COMPANIES.PHONE')}}
                div {{ company.phone }}
                acrm-input-phone.mb-1(slot="edit" v-model="company.phone") {{ $t('COMPANIES.PHONE')}}
            acrm-hidden-input.mb-3(v-model="company.registration_number" @save="save")
                label {{ $t('COMPANIES.REGISTRATION_NUMBER')}}
                div {{ company.registration_number }}
                acrm-input-line.mb-1(slot="edit" v-model="company.registration_number") {{ $t('COMPANIES.REGISTRATION_NUMBER')}}
            acrm-hidden-input.mb-3(v-model="company.tax_number" @save="save")
                label {{ $t('COMPANIES.TAX_NUMBER')}}
                div {{ company.tax_number }}
                acrm-input-line.mb-1(slot="edit" v-model="company.tax_number") {{ $t('COMPANIES.TAX_NUMBER')}}
            acrm-hidden-input.mb-3(v-model="company.extra_icon" @save="save")
                label {{ $t('COMPANIES.EXTRA_ICON')}}
                div {{ company.extra_icon }}
                acrm-input-line.mb-1(slot="edit" v-model="company.extra_icon") {{ $t('COMPANIES.EXTRA_ICON')}}
            acrm-hidden-input.mb-3(v-model="company.extra_icon_color" @save="save")
                label {{ $t('COMPANIES.EXTRA_ICON_COLOR')}}
                div {{ company.extra_icon_color }}
                acrm-input-line.mb-1(slot="edit" v-model="company.extra_icon_color") {{ $t('COMPANIES.EXTRA_ICON_COLOR')}}
            acrm-hidden-input.mb-3(v-model="company.extra_letters" @save="save")
                label {{ $t('COMPANIES.EXTRA_LETTERS')}}
                div {{ company.extra_letters }}
                acrm-input-line.mb-1(slot="edit" v-model="company.extra_letters") {{ $t('COMPANIES.EXTRA_LETTERS')}}
            acrm-hidden-input.mb-3(v-model="company.default_provider_company_id" @save="save")
                label {{ $t('COMPANIES.DEFAULT_PROVIDER')}}
                div
                    template(v-if="company.default_provider_company") {{ company.default_provider_company.name }}
                    template(v-else) &nbsp;
                acrm-company-selector(slot="edit" v-model="company.default_provider_company_id" type="provider")
            acrm-hidden-input.mb-3(v-if="company.is_allow_transfer !== undefined" v-model="company.is_allow_transfer" @save="save")
                label {{ $t('COMPANIES.IS_ALLOW_TRANSFER')}}
                div {{ company.is_allow_transfer ? $t('BASE.YES') : $t('BASE.NO') }}
                acrm-input-checkbox.mb-1(slot="edit" v-model="company.is_allow_transfer") {{ $t('COMPANIES.IS_ALLOW_TRANSFER')}}
</template>
